export default __webpack_public_path__ + "static/media/NotoSansKR-Regular.bf54b090.otf";